import { supabase } from '../lib/supabase';

class CompanySettingsService {
  async getActiveCompanySettings() {
    try {
      const { data, error } = await supabase?.from('company_settings')?.select('*')?.eq('is_active', true)?.maybeSingle();

      if (error) {
        console.warn('Supabase error fetching company settings:', error);
        return null;
      }

      return this.mapToCompanySettings(data);
    } catch (err) {
      console.warn('Error in getActiveCompanySettings:', err);
      return null;
    }
  }

  async updateCompanySettings(id, updates) {
    const mappedUpdates = {
      company_name: updates?.companyName,
      company_legal_name: updates?.companyLegalName,
      company_abbreviation: updates?.companyAbbreviation,
      company_logo_url: updates?.companyLogoUrl,
      primary_color: updates?.primaryColor,
      secondary_color: updates?.secondaryColor,
      contact_email: updates?.contactEmail,
      contact_phone: updates?.contactPhone,
      company_address: updates?.companyAddress,
      tax_identification_number: updates?.taxIdentificationNumber,
      business_registration_number: updates?.businessRegistrationNumber,
      industry: updates?.industry,
      company_size: updates?.companySize,
      timezone: updates?.timezone,
      currency: updates?.currency,
      date_format: updates?.dateFormat,
      updated_at: new Date()?.toISOString()
    };

    const { data, error } = await supabase?.from('company_settings')?.update(mappedUpdates)?.eq('id', id)?.select()?.single();

    if (error) throw error;

    return this.mapToCompanySettings(data);
  }

  async createCompanySettings(settings) {
    const mappedSettings = {
      company_name: settings?.companyName,
      company_legal_name: settings?.companyLegalName,
      company_abbreviation: settings?.companyAbbreviation,
      company_logo_url: settings?.companyLogoUrl,
      primary_color: settings?.primaryColor,
      secondary_color: settings?.secondaryColor,
      contact_email: settings?.contactEmail,
      contact_phone: settings?.contactPhone,
      company_address: settings?.companyAddress,
      tax_identification_number: settings?.taxIdentificationNumber,
      business_registration_number: settings?.businessRegistrationNumber,
      industry: settings?.industry,
      company_size: settings?.companySize,
      timezone: settings?.timezone,
      currency: settings?.currency,
      date_format: settings?.dateFormat,
      is_active: true
    };

    const { data, error } = await supabase?.from('company_settings')?.insert([mappedSettings])?.select()?.single();

    if (error) throw error;

    return this.mapToCompanySettings(data);
  }

  mapToCompanySettings(row) {
    if (!row) return null;

    return {
      id: row?.id,
      companyName: row?.company_name,
      companyLegalName: row?.company_legal_name,
      companyAbbreviation: row?.company_abbreviation,
      companyLogoUrl: row?.company_logo_url,
      primaryColor: row?.primary_color,
      secondaryColor: row?.secondary_color,
      contactEmail: row?.contact_email,
      contactPhone: row?.contact_phone,
      companyAddress: row?.company_address,
      taxIdentificationNumber: row?.tax_identification_number,
      businessRegistrationNumber: row?.business_registration_number,
      industry: row?.industry,
      companySize: row?.company_size,
      timezone: row?.timezone,
      currency: row?.currency,
      dateFormat: row?.date_format,
      isActive: row?.is_active,
      createdAt: row?.created_at,
      updatedAt: row?.updated_at
    };
  }
}

export default new CompanySettingsService();